const companies = {
	title: "Selskaper",
	new_company: "Nytt selskap",
	edit_company: "Rediger: {name}",
	view_company: "Vis: {name}",
	list_title: "Selskaper",
	list_subtitle: "Endre selskap",
	create_title: "Nytt selskap",
	update_title: "Oppdater selskap",
	company_access: "Brukere med tilgang",
	employees: "Arbeidsgiver",
	id: "ID",
	name: "Navn",
	vat: "Orgnr",
	requested_access: "Be om tilgang",
	confirm_approve_request: "Vil du tilgang til denne brukeren?",
	confirm_reject_request: "Vil du nekte tilgang for denne brukeren?",
	confirm_add_users: "Er du sikker på at du vil legge til valgte bruker(e)?",
	approve_success: "Bruker godkjent.",
	approve_failed: "Tilgangsgodkjenning feilet.",
	add_users_success: "Bruker(e) er lagt til.",
	reject_success: "Brukertilgang avvist.",
	reject_failed: "Tilgang kunne ikke nektes. Ta kontakt med administrator.",
	add_users_failed: "Bruker(e) ble ikke labgt til",
	issued_date: "Tilgang gitt fra",
	active_until: "Aktiv til",
	vat_does_not_exist: "Orgnr eksisterer ikke.",
};
export default companies;